import { useEffect, useState } from "react"
import { Alert, Button, Paper, TextField } from '@mui/material';
import Autocomplete from "@material-ui/lab/Autocomplete";
import MyTable from "../../custom-components/table";
import MyDialog from "../../custom-components/dialog";

import { db } from "../../firebase"


export default function IntermediateCoachingPageAdmin(props) {
    const { session, getSessions } = props
    const [table, settable] = useState([])
    const [available, setavailable] = useState([])
    // const [tableLoc, settableLoc] = useState([])
    const [playerPool, setplayerPool] = useState([])
    const [playerSearchBar, setplayerSearchBar] = useState(null)
    const [deleteDialogOpen, setdeleteDialogOpen] = useState(false)

    const sessionDBRef = db.collection('intermediate-coaching').doc(session.id)
    const availableDBRef = sessionDBRef.collection('available')
    const interCoachTableDBRef = sessionDBRef.collection('attendents')
    const columns = ['name', 'remove']
    const columnsAvailable = ['name', 'time', 'add']

    function getTable() {
        interCoachTableDBRef
            .get()
            .then((querySnapShot) => {
                let newTable = []
                querySnapShot.forEach((doc) => {
                    const ply = doc.data()
                    newTable.push({
                        uid: ply.uid,
                        name: ply.name,
                        email: ply.email,
                        time: ply.time,
                        remove: (<Button variant='outlined' color='error' onClick={(e) => {
                            e.stopPropagation();
                            e.nativeEvent.stopImmediatePropagation();
                            handleRemove(ply.uid)
                        }} >remove</Button>)
                    })
                })

                settable(newTable)
            }).catch((e) => {
                console.log(e)
            })
    }

    function getPlayerPool() {
        db.collection("appusers").get()
            .then((querySnapShot) => {
                var newPlayerPool = []
                querySnapShot.forEach((doc) => {
                    const data = doc.data()
                    const player = {
                        name: data.displayName,
                        email: data.email,
                        uid: data.uid,

                    }
                    newPlayerPool.push(player)
                })
                setplayerPool(newPlayerPool)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    function getAvailablePlys() {
        availableDBRef
            .get()
            .then((querySnapShot) => {
                let newAvailable = []
                querySnapShot.forEach((doc) => {
                    const ply = doc.data()
                    newAvailable.push({
                        uid: ply.uid,
                        name: ply.name,
                        email: ply.email,
                        time: ply.time,
                        add: (<Button variant='outlined' color='error' onClick={(e) => {
                            e.stopPropagation();
                            e.nativeEvent.stopImmediatePropagation();
                            addFromAvailable(ply.uid)
                        }} >Add</Button>)
                    })
                })

                setavailable(sortAvailable(newAvailable))
            })
    }

    function sortAvailable(plys) {
        plys.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.time) - new Date(a.time);
        });
        return plys
    }

    // remove ply from list, add to available list
    function handleRemove(uid) {
        console.log('ply to remove', uid)
        interCoachTableDBRef.doc(uid)
            .delete()
            .then(() => {
                getTable()
                getAvailablePlys()
            })
            .catch((e) => {
                console.log(e)
            })
    }

    // add ply to list, remove from available list
    function addFromAvailable(uid) {
        console.log('ply to remove', uid)
        availableDBRef.doc(uid)
            .get()
            .then((doc) => {
                const ply = doc.data()
                interCoachTableDBRef.doc(ply.uid)
                    .set(ply)
                    .then(() => {
                        availableDBRef.doc(uid)
                            .delete()
                            .then(() => {
                                getTable()
                                getAvailablePlys()
                            })
                            .catch((e) => {
                                console.log(e)
                            })
                    })
                    .catch(() => {
                        console.error('Error add removed player to available')
                    })
            })
            .catch(() => {
                console.error('Error remove ply from list')
            })
    }

    function addAttendent() {
        const playerToAdd = {
            uid: playerSearchBar.uid,
            name: playerSearchBar.name,
            email: playerSearchBar.email,
        }

        interCoachTableDBRef.doc(playerToAdd.uid)
            .set(playerToAdd)
            .then(() => {
                getTable()
            })
            .catch((e) => {
                console.log(e)
            })
    }

    // delete session
    function handleClickDeleteSession() {
        setdeleteDialogOpen(true)
    }

    function handleConfirmDialog() {
        deleteSession()
        setdeleteDialogOpen(false)
    }

    function handleCloseDialog() {
        setdeleteDialogOpen(false)
    }

    function deleteSession() {
        sessionDBRef
            .delete()
            .then(() => {
                getSessions()
            })
            .catch((e) => {
                console.log(e)
            })
    }

    useEffect(() => {
        getTable()
        getAvailablePlys()
    }, [session])

    useEffect(() => {
        console.log('playersearchbar', playerSearchBar)
    }, [playerSearchBar])

    useEffect(() => {
        console.log('table', table)
    }, [table])

    useEffect(() => {
        getPlayerPool()
    }, [])


    const dialogContent = <p>Do you want to delete this session?</p>

    return (
        <div>
            <h3>{session.sessionName}</h3>
            <p>Date: {session.date}</p>
            <p>Time: {session.time}</p>

            <div className="flex-row">
                <Paper className="margin">
                    {/* player table */}
                    <Paper className='center margin padding flex'>
                        <h5>Add attendees here: </h5>
                        <Autocomplete
                            id="search-bar"
                            onChange={(event, newval) => {
                                setplayerSearchBar(newval)
                            }}
                            options={playerPool}
                            getOptionLabel={(option) => option.name + ' ' + option.email}
                            style={{ width: 300 }}
                            renderInput={(params) => <TextField {...params} label="Users" />}
                        />

                        <Button variant='outlined' color='success' onClick={addAttendent} >Add</Button>
                    </Paper>
                    <MyTable columns={columns} rows={table}></MyTable>
                </Paper>
            </div>
            <Button variant="contained" color="error" onClick={handleClickDeleteSession} >Delete session</Button>

            <MyDialog open={deleteDialogOpen} dialogTitle='Add session' dialogContent={dialogContent} onConfirm={handleConfirmDialog} closeDialog={handleCloseDialog} ></MyDialog>
        </div>
    )
}